module.exports = __webpack_public_path__ + "img/15_82.24d77ba9.png";